import { CreateMUIStyled, styled as _styled } from '@mui/material/styles';
import { AppTheme } from './model';

export const styled = _styled as CreateMUIStyled<AppTheme>;
